// Product names are independent of the manufacturer's wire protocol identifiers.
export const FALLBOX_MODEL = 'Faldalarmboks';
export const FALLBOX_FEATURES = ['position','history','geofence','activity','calling','medication','settings','find','uploadInterval','photo','fall','lowBattery','sos','batteryLevel','signal'];
// Only commands documented for this product. No health sensor or wrist-removal commands.
export const FALLBOX_COMMANDS = ['PEDO','WALKTIME','PROFILE','FALLDOWN','LSSET','SOS','SMSONOFF','APPLOCK','REMIND','TAKEPILLS','MONITOR','HSW','SPOF','DEVREFUSEPHONESWITCH'];
export const isFallbox = profile => profile?.model === FALLBOX_MODEL;
export function publicFirmware(profile, value) {
  if (!isFallbox(profile)) return value;
  // Display the actual version/build date; retain the complete firmware privately.
  return typeof value === 'string' ? value.match(/(?:^|_)(V\d+(?:\.\d+)+_[\d._]+)$/)?.[1] ?? null : null;
}
export function personalAlarmText(text, fallbox, locale='da-DK') {
  if (!fallbox) return text;
  return locale === 'da-DK'
    ? text.replace(/armbåndets/gi, word => word[0] === 'A' ? 'Enhedens' : 'enhedens').replace(/armbåndet/gi, word => word[0] === 'A' ? 'Enheden' : 'enheden').replace(/armbånd/gi, word => word[0] === 'A' ? 'Enhed' : 'enhed')
    : text.replace(/bracelet/gi, word => word[0] === 'B' ? 'Device' : 'device');
}
